import React from 'react';
import './Loader.scss';

export type LoaderProps = {
    className?: string;
    small?: boolean;
    verysmall?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Loader: React.FC<LoaderProps> = ({
    className,
    small = false,
    verysmall = false,
}) => {
  

    return (
        <div className={className}><div className={`loader ${small ? 'small' : ''} ${verysmall ? 'verysmall' : ''}`}></div></div>
    );
};
